import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, Alert, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import ApplicationHeader from '../components/ApplicationHeader';

export default function ContractorApplicationStatusPage() {
  const { approvalStatus: authApprovalStatus, logout } = useAuth();
  const navigate = useNavigate();
  const [approvalStatus, setApprovalStatus] = useState(authApprovalStatus);
  const [rejectionReason, setRejectionReason] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/contractors-onboarding/application/status')
      .then((res) => {
        if (res.data?.success && res.data?.data) {
          setApprovalStatus(res.data.data.approvalStatus);
          setRejectionReason(res.data.data.rejectionReason);
        }
      })
      .catch(() => {
        // Fall back to approvalStatus from AuthContext — already set as initial state
      })
      .finally(() => setLoading(false));
  }, []);

  const rejected = approvalStatus === 'rejected';

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        <ApplicationHeader title="Contractor Application" onLogout={logout} />
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 10 }}>
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <ApplicationHeader title="Contractor Application" onLogout={logout} />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, mt: { xs: 4, md: 8 } }}>
      <Paper sx={{ p: 4, maxWidth: 520, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          {rejected ? 'Your application needs changes' : 'Application under review'}
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          {rejected
            ? 'An admin has asked for changes. Edit your application and resubmit for review.'
            : 'Thanks for applying to Eqaya. Our team is reviewing your application and will be in touch.'}
        </Typography>
        {rejected && (
          <Alert severity="warning" sx={{ mb: 3, textAlign: 'left' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
              Reason for rejection:
            </Typography>
            <Typography variant="body2">
              {rejectionReason || 'An admin requested changes to your application.'}
            </Typography>
          </Alert>
        )}
        <Button variant="contained" onClick={() => navigate('/contractor/apply')} sx={{ mr: 1 }}>
          {rejected ? 'Edit & resubmit' : 'Edit application'}
        </Button>
        <Button variant="text" onClick={logout}>Log out</Button>
      </Paper>
      </Box>
    </Box>
  );
}
